import { Selector } from '@ngxs/store';
import { NavigationStateModel } from './navigation.state-model';

export class NavigationSelectors {
  @Selector()
  static currentReturnUrl(state: NavigationStateModel): string | null {
    const overrideUrl = state.overrideReturnUrls[state.overrideReturnUrls.length - 1];
    const defaultUrl = state.defaultReturnUrls[state.defaultReturnUrls.length - 1];
    return overrideUrl || defaultUrl || null;
  }

  @Selector()
  static defaultReturnUrls(state: NavigationStateModel): string[] {
    return state.defaultReturnUrls;
  }

  @Selector()
  static overrideReturnUrls(state: NavigationStateModel): string[] {
    return state.overrideReturnUrls;
  }
}
